import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as ReactRedux from 'react-redux';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';

const DisableOverlay = ({
  activeTooltipIndex,
  isEmptyState,
  isTourDisplayed,
}) => {
  const isAnswerQuestionTooltipDisplayed = isTourDisplayed &&
  (activeTooltipIndex === SelfServeTooltipTourConstants.ANSWER_QUESTION_TOOLTIP_IDX);

  const disableOverlayClasses = classNames(
    'recipient-builder-empty-state-background',
    {
      'disable-menu-and-progress-bar': isAnswerQuestionTooltipDisplayed,
    },
  );

  const isDisableOverlayDisplayed = isEmptyState || isAnswerQuestionTooltipDisplayed;

  if (isDisableOverlayDisplayed) {
    return (
      <div className={disableOverlayClasses} />
    );
  }

  return null;
};

DisableOverlay.defaultProps = {
  isEmptyState: false,
};

DisableOverlay.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  isEmptyState: PropTypes.bool,
  isTourDisplayed: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
});

export default ReactRedux.connect(
  mapStateToProps,
)(DisableOverlay);



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/DisableOverlay.jsx